const state = {
	isShowingVersionDialog: false,
	isShowingSendReminderDialog: false,
	isShowingDeleteCertDialog: false,

	currentEmployeeId: null,
	currentCertTypeId: null,

	selectedCert: null,
	isDeletingCertification: false,
	isSendingReminder: false,
	isDownloading: false,
}

const getters = {
	deletingId: state => state.isDeletingCertification && state.selectedCert !== null  ? state.selectedCert.id : null,
	remindingId: state => state.isSendingReminder && state.selectedCert !== null  ? state.selectedCert.id : null,
	downloadingId: state => state.isDownloading && state.selectedCert !== null ? state.selectedCert.id : null,
}

const actions = {
	async handleDownload({commit, dispatch}, cert) {
		commit("SET_PROPERTY", { key: 'selectedCert', value: cert })
		commit("SET_PROPERTY", { key: 'isDownloading', value: true })
		await dispatch("certifications/download", cert.id, { root: true })
		commit("SET_PROPERTY", { key: 'selectedCert', value: null })
		commit("SET_PROPERTY", { key: 'isDownloading', value: false })
	},
	handleVersion({commit, dispatch}, cert) {
		commit("SET_PROPERTY", { key: 'selectedCert', value: cert })
		commit("SET_PROPERTY", { key: 'isShowingVersionDialog', value: true })
	},
	handleReminder({commit, dispatch}, cert) {
		commit("SET_PROPERTY", { key: 'selectedCert', value: cert })
		commit("SET_PROPERTY", { key: 'isShowingSendReminderDialog', value: true })
	},
	handleDelete({commit, dispatch}, cert) {
		commit("SET_PROPERTY", { key: 'selectedCert', value: cert })
		commit("SET_PROPERTY", { key: 'isShowingDeleteCertDialog', value: true })
	},
	async confirmDelete({commit, dispatch}, cert) {
		commit("SET_PROPERTY", { key: 'isDeletingCertification', value: true })
		const result = await dispatch("certifications/delete", state.selectedCert.id, { root: true })
		if (result.isSuccess) {
			commit("SET_PROPERTY", { key: 'selectedCert', value: null })
			commit("SET_PROPERTY", { key: 'isShowingDeleteCertDialog', value: false })
		}
		commit("SET_PROPERTY", { key: 'isDeletingCertification', value: false })
	},
	async confirmReminder({commit, dispatch, state}) {
		commit("SET_PROPERTY", { key: 'isSendingReminder', value: true })
		const result = await dispatch("certifications/sendReminder", state.selectedCert.id, { root: true })
		if (result.isSuccess) {
			commit("SET_PROPERTY", { key: 'selectedCert', value: null })
			commit("SET_PROPERTY", { key: 'isShowingSendReminderDialog', value: false })
		}
		commit("SET_PROPERTY", { key: 'isSendingReminder', value: false })
	},
	cancelReminder({commit}) {
		commit("SET_PROPERTY", { key: 'selectedCert', value: null })
		commit("SET_PROPERTY", { key: 'isShowingSendReminderDialog', value: false })
	},
	cancelDelete({commit}) {
		commit("SET_PROPERTY", { key: 'selectedCert', value: null })
		commit("SET_PROPERTY", { key: 'isShowingDeleteCertDialog', value: false })
	},
	cancelVersion({commit}) {
		commit("SET_PROPERTY", { key: 'isShowingVersionDialog', value: false })
		commit("SET_PROPERTY", { key: 'selectedCert', value: null })
	},
	setProp({commit}, {key, value}) {
		commit("SET_PROPERTY", { key, value })
	}

}

const mutations = {
	SET_PROPERTY(state, {key, value}) {
		state[key] = value;
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};